module.exports = __webpack_public_path__ + "assets/images/bf6ed167ad35f6f558ba4cde5aeae88b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/portfolio/directv-pattern-cloud/dtv-pattern-cloud-1.jpg
// module id = 800
// module chunks = 0